import React, { useContext, useEffect } from "react";
import _ from "lodash";
import AppBar from "../components/headerNav/HeaderNav";
import { Container } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import { UserContext } from "../context/UserContext";
import UserGriddle from "../components/user-management/UserGriddle";
import "../styles/user.scss";
import Footer from "../components/footer/Footer";
import { UserRoles } from "../constants/UserRoles";
import CookieConsentBanner from "../components/cookie-consent/CookieConsentBanner";

const UserManagement = () => {
  const { lists, userList, _setLoading, fetchUsers, display,  userRole, initialFetch } = useContext(UserContext);

  useEffect(() => {
    if(userList.length && !initialFetch) {
      _setLoading(true);
      fetchUsers();
      return () => {
        _setLoading(false);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList.length]);

  return !_.isEmpty(userRole) && (userRole === UserRoles.ADMIN || userRole === UserRoles.SUPERADMIN || userRole === UserRoles.GLOBALADMIN) ? (
    <Container
      fluid
      className="userContainer">
      <Grid container>
        <AppBar />
        <Grid
          item
          xs={12}
          className="mt-5">
          {_.isEmpty(userList) || !display ? (
            _.isEmpty(userList) && !_.isEmpty(lists) && display ? (
              <span>No data found</span>
            ) : null
          ) : (
            <UserGriddle />
          )}
        </Grid>
        <Footer />
        <CookieConsentBanner />
      </Grid>
    </Container>
  ) : null ;
};
export default UserManagement;
